import { useIntl } from '@capsicum/common';

export const useNCWSendAssetNoSearchResults = () => {
	const { $t } = useIntl();

	const noSearchResultTitle = $t('ncWallet.send.assetSelector.noSearchResultTitle');
	const noSearchResultDescription = $t('ncWallet.send.assetSelector.noSearchResultDescription');

	return {
		intlText: {
			noSearchResultDescription,
			noSearchResultTitle
		}
	};
};
